export type OrcaRoutingCreditKey = "intelligence" | "assistant" | "agent"

export const ORCA_ROUTING_CREDIT_COPY: Record<OrcaRoutingCreditKey, {
  shortCredit: string
  detailCredit: string
}> = {
  intelligence: {
    shortCredit: "Included for all of your project chat and intelligence needs.",
    detailCredit:
      "Project Q&A is included. Reading existing project context, report details, and workspace information does not spend credits.",
  },
  assistant: {
    shortCredit:
      "Credits are used when Orca creates or updates work; try it by selecting a smart tool to create something for your project.",
    detailCredit:
      "Focused creation, revision, or project-update help can use credits. Orca checks the balance and shows the cost before credit-spending work starts.",
  },
  agent: {
    shortCredit:
      "Your agent will need credits for any delegated tasks or schedules you have it maintain; deeper workflows may use more credits, but you will always be asked to approve first.",
    detailCredit:
      "Delegated multi-step work can use more credits because Orca can plan, use tools, and prepare project material. Orca may also ask for approval before specific write or delegated steps.",
  },
}
